export default __webpack_public_path__ + "static/media/favoritewhite.890b3987.svg";